<template>
  <model-form
    ref="modelForm"
    :model="showing"
  >
    <q-tabs
      v-model="tab"
      dense
      animated
      keep-alive
      class="text-grey"
      active-color="primary"
      indicator-color="primary"
      align="justify"
    >
      <q-tab
        v-if="seatChartForShowing && seatChartForShowing.isRemote"
        name="seat-chart"
        label="Seat Chart"
      />
      <q-tab
        name="tickets"
        label="Tickets"
      />
      <q-tab
        name="orders"
        label="Orders"
      />
    </q-tabs>
    <q-tab-panels
      v-model="tab"
      animated
    >
      <q-tab-panel
        name="seat-chart"
        class="row justify-center"
      >
        <seat-chart
          v-if="seatChartForShowing && seatChartForShowing.isRemote"
          ref="seatChart"
          :edit-mode="true"
          class="col"
          style="max-width: 500px;"
          :seat-chart="seatChartForShowing"
          :seat-chart-options="seatChartForShowing.seatChartOptions"
          :seats-to-select="0"
          :initial-selected-seats="[]"
          :show-seat-numbers="true"
          @select-seat="val => selectSeat(val)"
        />
      </q-tab-panel>
      <q-tab-panel
        name="tickets"
      >
        <model-table
          ref="ticketTable"
          :collection="tickets"
          :submodel="true"
          :columns="[
            { field: 'id' },
            { field: 'state', component: OrderStateCell },
            { name: 'ticketType', field: ticket => ticket.ticketType.name, component: 'chip' },
            { name: currentSite.ticketPriceLabel, field: 'price', component: 'money' },
            { field: 'seatName', component: 'chip' },
            { name: 'user', field: 'name', component: 'chip' },
            { name: 'order', field: ticket => `Order ${ticket.order.id}`, component: 'chip' },
          ]"
          :show-add="false"
          :show-edit="false"
        >
          <ticket-form :available-seats="seatChartForShowing.availableSeatsWithoutSocialDistancing" />
        </model-table>
      </q-tab-panel>
      <q-tab-panel
        name="orders"
      >
        <model-table
          :collection="showing.orders"
          :submodel="true"
          :columns="[
            { field: 'id' },
            { name: 'state', component: OrderStateCell },
            { name: 'user', field: order => order.name, component: 'chip' },
            { name: 'orderItems', component: OrderItemsCell },
            { field: 'total', component: 'money' },
            { field: 'registerStation', component: 'model' },
            { field: 'employee', component: 'model' },
            { field: 'createdAt' },
          ]"
          sort-by="id"
          :descending="true"

          :show-add="false"
          :show-edit="false"
          @edit="order => $editModel(order)"
        />
      </q-tab-panel>
    </q-tab-panels>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import ModelTable from 'src/modules/admin/components/ModelTable'
import OrderItemsCell from 'src/modules/admin/order/components/OrderItemsCell'
import OrderStateCell from 'src/modules/admin/order/components/OrderStateCell'
import SeatChart from 'src/modules/admin/seat-chart/SeatChart'
import TicketForm from 'src/modules/admin/showing/TicketForm'

export default {
  name: 'OrderForm',
  components: {
    ModelForm,
    ModelTable,
    TicketForm,
    SeatChart
  },
  configuration: ['currentSite'],
  data: function () {
    return {
      tab: 'tickets'
    }
  },
  created () {
    this.OrderStateCell = OrderStateCell
    this.OrderItemsCell = OrderItemsCell
  },
  models: {
    showing: {
      orders: {
        user: 'default',
        orderItems: {
          itemOrderItem: {
            item: true,
            itemVariation: true,
            itemModifiers: {
              modifier: true
            }
          },
          ticket: {
            fields: 'all',
            showing: {
              movie: 'default'
            }
          },
          voucherPurchase: {
            voucherType: true,
            card: 'default'
          },
          membershipInterval: 'default',
          tax: true,
          discount: 'default',
          voucher: {
            voucherType: true
          },
          voucherType: true,

          order: 'default'
        },
        employee: {
          fields: ['id', 'firstName', 'lastName']
        },
        skipWatchers: true
      }
    },
    tickets: {
      order: {
        fields: ['id', 'deliveryFirstName', 'deliveryLastName', 'nameForOrder'],
        user: {
          fields: ['id', 'firstName', 'lastName']
        }
      },
      user: {
        fields: ['id', 'firstName', 'lastName']
      },
      ticketType: {
        fields: ['id', 'name']
      },
      variables () {
        return {
          showingId: this.showing.id
        }
      }
    },
    seatChartForShowing: {
      seatChartOptions: true,
      seatChart: true,
      variables () {
        return {
          // Trigger force reload when saved
          showingId: this.showing.loading ? this.showing.id : this.showing.id
        }
      },
      force: true
    }
  },
  methods: {
    async selectSeat (seatName) {
      this.tab = 'tickets'

      await this.$nextTick()

      if (this.$refs.ticketTable) this.$refs.ticketTable.filter = seatName
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
